// extracted by mini-css-extract-plugin
export default {"disBlock":"modal_disBlock__szWCz","disNone":"modal_disNone__bPPsH","bgmain":"modal_bgmain__hnHgC","successbody":"modal_successbody__F7-VD","closesuccess":"modal_closesuccess__SB3QL"};